import { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [currentTenant, setCurrentTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTenantData = async (tenantId) => {
    if (!tenantId) {
      setCurrentTenant(null);
      setLoading(false);
      return;
    }

    try {
      const tenantDoc = await getDoc(doc(db, 'tenants', tenantId));
      if (tenantDoc.exists()) {
        setCurrentTenant({ id: tenantId, ...tenantDoc.data() });
      } else {
        setCurrentTenant(null);
      }
    } catch (error) {
      console.error('Error fetching tenant:', error);
      setCurrentTenant(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          await fetchTenantData(userData.tenantId);
        }
      } else {
        setCurrentTenant(null);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <TenantContext.Provider value={{ currentTenant, loading, refreshTenant: fetchTenantData }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
